import React from 'react'

export const useInitialPersonalInfoValues = ({
  personal,
  defaultCountryValue,
  defaultPhoneCodeValue,
  deliveryType,
  payType
}) => {
  return React.useMemo(() => {
    return {
      ...personal,
      country: defaultCountryValue,
      phone_code: defaultPhoneCodeValue,
      deliveryType,
      payType
    }
  }, [personal, defaultCountryValue, defaultPhoneCodeValue, deliveryType, payType])
}
